module.exports = function (url) {
    window.history.pushState(
        {
            url: url || window.location.href.split(window.location.hostname)[1],
            random: Math.random()
        },
        document.getElementsByTagName('title')[0].innerText,
        url || window.location.href.split(window.location.hostname)[1]
    );
}


// WEBPACK FOOTER //
// ./core/xhr2/modules/createState.js